<template>
  <div class="book-content-wrapper">
    <transition name="fade-header">
      <div class="book-title fd-js-excludes">
        <div style="width: 300px;">
          <EditHeader :backShow="true" headerTitle="数字内容编辑"></EditHeader>
        </div>
        <el-tooltip popper-class="header-tooltip" effect="light" :content="book.title" placement="bottom">
          <div class="shareHeader fd-js-excludes">
            <span class="fd-js-excludes">{{ book.title }}</span>
          </div>
        </el-tooltip>
        <button class="digital-button" @click="gotoPaper">阅读效果编辑</button>
      </div>
    </transition>
    <div style="position: relative;width: 100%;height: 100%;background: #999999;">
      <DigitalNavigation
        ref="digitalNavigation"
        :width="300"
        :pages="pages"
        :articles="articles"
        :is-show-tab="isShowTab"
        :init-tab-index="tabIndex"
        :init-page-index="pageIndex"
        :init-article-index="articleIndex"
        @onChangeTab="onChangeTab"
        @onChangePage="onChangePage"
        @onChangeArticle="onChangeArticle"
      ></DigitalNavigation>
      <DigitalPage
        :pages="pages"
        :top="22"
        :bottom="88"
        :left="300"
        :right="400"
        :edit="true"
        ref="digitalPage"
        @onCreate="onCreate"
        @onSelectedPageElement="onSelectedPageElement"
        @onAreaClick="onAreaClick"
        @update-config="(value) => (btnImgConfig = value)"
        @del-config="(val) => deletePic.push(val)"
        @update-obj="(val) => (updateObj = val)"
        @add-icon="(val) => addICons.push(val)"
      ></DigitalPage>
      <DigitalArticleEdit
        :editor-disabled="!articleXiaoYangId"
        ref="digitalArticleEdit"
        :width="400"
        :init-article-title="articleTitle"
        :init-article-text="articleText"
        @onChange="onChange"
      ></DigitalArticleEdit>
      <DigitalSaveButton
        ref="digitalSaveButton"
        :bottom="22"
        :left="300"
        :right="400"
        :init-page-index="pageIndex"
        :init-page-total="pageTotal"
        @onPrev="onPrev"
        @onNext="onNext"
        @onSave="onSave"
      ></DigitalSaveButton>
    </div>
    <div class="digital-tips" v-if="digitalTips.status">
      <div class="box">
        <div class="head">
          <div class="title">{{ digitalTips.title }}</div>
          <div class="close" @click="digitalTips.cancelCallback">x</div>
        </div>
        <div class="tips">
          <div class="text">{{ digitalTips.text }}</div>
        </div>
        <div class="btns">
          <button class="yes" v-if="digitalTips.yes !== ''" @click="digitalTips.yesCallback">{{ digitalTips.yes }}</button>
          <button class="no" v-if="digitalTips.no !== ''" @click="digitalTips.noCallback">{{ digitalTips.no }}</button>
          <button class="cancel" v-if="digitalTips.cancel !== ''" @click="digitalTips.cancelCallback">{{ digitalTips.cancel }}</button>
        </div>
      </div>
    </div>
    <div class="digital-loading" v-if="dataLoading">
      <div class="text">加载中...</div>
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
  </div>
</template>
<script>
import getBook from '@api/getBook'
import setBook from '@api/setBook'
import EditHeader from '../components/editDrawer/edit/EditHeader'
import DigitalNavigation from '../components/digital/DigitalNavigation'
import DigitalArticleEdit from '../components/digital/DigitalArticleEdit'
import DigitalPage from '../components/digital/DigitalPage'
import DigitalSaveButton from '../components/digital/DigitalSaveButton'
import { setEncryption } from '@/utils'
import { formatDigitalArticle } from '@/utils'
import compareVipRight from '@components/common/compareVipRight.js'
import { mapState } from 'vuex'
import TipDialog from '@components/common/TipDialog.vue'

export default {
  name: 'Digital',
  mixins: [compareVipRight],
  components: {
    EditHeader,
    DigitalSaveButton,
    DigitalPage,
    DigitalArticleEdit,
    DigitalNavigation,
    TipDialog
  },
  data() {
    return {
      saveEvent: () => {
        if (event.ctrlKey == true && event.keyCode == 83) {
          event.preventDefault()
          event.returnvalue = false
          this.save()
        }
      }, // 保存的事件对象
      timer: new Date().getTime(),
      digital: null, // 数字对象
      book: {},
      pages: [],
      articles: [],
      articleIndex: 0,
      articleXiaoYangId: 0,
      articleTitle: '',
      articleText: '',
      articleTitleOld: '',
      articleTextOld: '',
      articleFileAttachIds: [],
      articleTextEditStatus: true, // 内容编辑状态，true：articleText与articleTextOld同时变化，false：仅articleText发生变化
      pageIndex: 1,
      pageTotal: 0,
      pageSizeList: [],
      isShowTab: true,
      tabIndex: 1,
      readModel: 0,
      readingLog: {},
      isEditArticle: false,
      dataLoading: false,
      // 提示框的数据结构
      digitalTips: {
        status: false,
        title: '提示',
        text: '您的修改尚未保存，是否保存？',
        yes: '保存',
        yesCallback: () => {
          console.log('yes click')
        },
        no: '不保存',
        noCallback: () => {
          console.log('no click')
        },
        cancel: '取消',
        cancelCallback: () => {
          this.digitalTips.status = false
        }
      },
      btnImgConfig: null,
      deletePic: [],
      updateObj: {},
      addICons: []
    }
  },
  computed: {
    ...mapState('book'),
    listToEditPageNo() {
      return this.$store.state.edit.listToEditPageNo
    },
    isPaper() {
      return this.$route.query.type === 'paper'
    },
    paperStyle() {
      return this.$store.state.config.paperStyle
    },
    isBook() {
      return this.$route.query.type === 'book'
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  created() {
    this.$store.dispatch('common/login')
  },
  mounted() {
    // 请求书刊详情
    const params = {
      id: this.$route.query.id,
      module: this.isBook ? 'ebook' : 'epaper'
    }
    this.dataLoading = true
    // this.$store.commit('book/UPDATE_IS_PAPER', true)
    this.getVipInfo()
    this.getBookDetails(params, (book) => {
      if (book.creator != localStorage.getItem('username')) {
        this.$message({ message: '您无权编辑此作品，即将返回首页', type: 'warning' })
        setTimeout(() => {
          this.$router.push({ path: '/' })
        }, 3000)
        return
      }
      this.$store.commit('book/UPDATE_BOOK_DATA', book)
      this.$setDocumentTitle(book.title)
      this.getHotspotList({ module: this.isBook ? 'ebook' : 'epaper', moduleDataId: this.$route.query.id }, (hotspotList) => {
        this.getDaYangByEpaperId(params, (daYangList) => {
          // 转换大样与页面的关系数据
          let daYangArray = []
          for (let a in daYangList) {
            if (daYangList.hasOwnProperty(a)) {
              daYangArray[daYangList[a].pageNo] = daYangList[a]
            }
          }
          // 书籍信息
          this.book = book
          this.pageTotal = book.pageNumber
          this.$store.commit('book/UPDATE_TOTAL_PAGE', book.pageNumber)
          this.readModel = book.readModel
          // 导览页面列表
          this.pages = []
          for (let i = 1; i <= book.pageNumber; i++) {
            let resources = []
            for (let b in hotspotList) {
              if (hotspotList.hasOwnProperty(b)) {
                if (i == hotspotList[b].pageIden) {
                  let type = undefined
                  if (hotspotList[b].contentType === 0) {
                    type = 'audio'
                  } else if (hotspotList[b].contentType === 1) {
                    type = 'video'
                  } else if (hotspotList[b].contentType === 2) {
                    type = 'link'
                  } else if (hotspotList[b].contentType === 3) {
                    type = 'picture'
                  } else if (hotspotList[b].contentType === 4) {
                    type = 'innerVideo'
                  }
                  let coordinates = JSON.parse(hotspotList[b].coordinates)
                  let res = {
                    id: hotspotList[b].id,
                    type: type,
                    top: coordinates.top,
                    left: coordinates.left,
                    width: coordinates.width,
                    height: coordinates.height,
                    topScale: coordinates.top,
                    leftScale: coordinates.left,
                    widthScale: coordinates.width,
                    heightScale: coordinates.height,
                    zindex: parseInt(b),
                    resize: false,
                    edit: false
                  }
                  if (type === 'link') {
                    const href = hotspotList[b].contentPath
                    if (href === 'pre' || href === 'next' || href === 'first') {
                      res.linkType = 1
                      res.pageS = href
                    } else if (/^[0-9]+$/.test(href)) {
                      res.linkType = 1
                      res.pageS = 'page'
                      res.page = href
                    } else {
                      res.linkType = 0
                      res.href = hotspotList[b].contentPath
                    }
                    res.btnStyle = hotspotList[b].btnStyle
                    res.btnPath = hotspotList[b].btnPath
                    res.btnAttachId = hotspotList[b].btnAttachId
                  } else {
                    res.file = hotspotList[b].fileAttachName
                    res.fileid = hotspotList[b].fileAttachId
                    res.path = hotspotList[b].contentPath
                    res.controls = hotspotList[b].playControl === 1
                    res.autoplay = hotspotList[b].playAuto === 1
                    res.loopplay = hotspotList[b].playLoop === 1
                    res.btnStyle = hotspotList[b].btnStyle
                    res.btnPath = hotspotList[b].btnPath
                    res.btnAttachId = hotspotList[b].btnAttachId
                    res.vodFileId = hotspotList[b].vodFileId
                  }
                  resources.push(res)
                }
              }
            }
            this.pages.push({
              image: book.path + '/' + daYangList[i - 1].pageNo + '.jpg' + '?v=' + this.timer,
              index: i,
              width: 0,
              height: 0,
              resources: resources,
              coordinates: [],
              dayangid: daYangList[i - 1]?.id
            })
          }
          // 导览文章列表
          if (book.catalog) {
            let catalog = JSON.parse(book.catalog)
            this.articles = (catalog ? catalog.catalogList : []) || []
          } else {
            this.articles = []
          }
          this.$store.commit('book/UPDATE_BOOK_CATALOG_LIST', this.articles)

          if (this.articles.length === 0) {
            this.isShowTab = false
          }
          let dayangid = this.pages[this.pageIndex - 1]?.dayangid
          this.getPageWH(book.path, this.pageIndex, (imgWidth, imgHeight) => {
            // 根据报刊类型判断是否需要加载文章及热区数据
            if (dayangid) {
              // 加载某页面的热区数据
              this.loadXiaoYangList(this.pageIndex, () => {
                // 初始化页面
                // 初始化富文本内容
                this.digital.changePage(this.pageIndex)
                this.saveReadingLog(this.pageIndex)
                this.getXiaoYangDetailInfo(this.getFirstArticleXiaoYangId(this.pageIndex))
              })
            } else {
              setTimeout(() => {
                // 初始化页面
                // 初始化富文本内容
                this.digital.changePage(this.pageIndex)
                this.saveReadingLog(this.pageIndex)
                this.getXiaoYangDetailInfo(this.getFirstArticleXiaoYangId(this.pageIndex))
              }, 100)
            }
            // Ctrl+s保存快捷键
            document.addEventListener('keydown', this.saveEvent)
          })
        })
      })
    })
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.saveEvent)
  },
  methods: {
    reloadHotspotList(callback) {
      //更新目录
      this.getBookDetails({ id: this.$route.query.id }, (book) => {
        // 导览文章列表
        if (book.catalog) {
          let catalog = JSON.parse(book.catalog)
          this.articles = (catalog ? catalog.catalogList : []) || []
        } else {
          this.articles = []
        }
        this.$store.commit('book/UPDATE_BOOK_CATALOG_LIST', this.articles)
        if (this.articles.length > 0) {
          this.isShowTab = true
        } else {
          this.isShowTab = false
        }
      })
      this.getHotspotList({ module: this.isBook ? 'ebook' : 'epaper', moduleDataId: this.$route.query.id }, (hotspotList) => {
        const params = {
          id: this.$route.query.id,
          module: this.isBook ? 'ebook' : 'epaper'
        }
        this.getDaYangByEpaperId(params, (daYangList) => {
          let daYangArray = []
          for (let a in daYangList) {
            if (daYangList.hasOwnProperty(a)) {
              daYangArray[daYangList[a].pageNo] = daYangList[a]
            }
          }
          for (let a in this.pages) {
            if (this.pages.hasOwnProperty(a)) {
              this.pages[a].dayangid = daYangArray[this.pages[a].index]?.id
              this.pages[a].resources = []
              for (let b in hotspotList) {
                if (hotspotList.hasOwnProperty(b)) {
                  if (parseInt(this.pages[a].index) === parseInt(hotspotList[b].pageIden)) {
                    let type = undefined
                    if (hotspotList[b].contentType === 0) {
                      type = 'audio'
                    } else if (hotspotList[b].contentType === 1) {
                      type = 'video'
                    } else if (hotspotList[b].contentType === 2) {
                      type = 'link'
                    } else if (hotspotList[b].contentType === 3) {
                      type = 'picture'
                    } else if (hotspotList[b].contentType === 4) {
                      type = 'innerVideo'
                    }
                    let coordinates = JSON.parse(hotspotList[b].coordinates)
                    let res = {
                      id: hotspotList[b].id,
                      type: type,
                      top: coordinates.top,
                      left: coordinates.left,
                      width: coordinates.width,
                      height: coordinates.height,
                      topScale: coordinates.top,
                      leftScale: coordinates.left,
                      widthScale: coordinates.width,
                      heightScale: coordinates.height,
                      zindex: parseInt(b),
                      resize: false,
                      edit: false,
                      btnStyle: hotspotList[b].btnStyle,
                      btnPath: hotspotList[b].btnPath,
                      btnAttachId: hotspotList[b].btnAttachId
                    }
                    if (type === 'link') {
                      const href = hotspotList[b].contentPath
                      if (href === 'pre' || href === 'next' || href === 'first') {
                        res.linkType = 1
                        res.pageS = href
                      } else if (/^[0-9]+$/.test(href)) {
                        res.linkType = 1
                        res.pageS = 'page'
                        res.page = href
                      } else {
                        res.linkType = 0
                        res.href = hotspotList[b].contentPath
                      }
                    } else {
                      res.file = hotspotList[b].fileAttachName
                      res.fileid = hotspotList[b].fileAttachId
                      res.path = hotspotList[b].contentPath
                      res.controls = hotspotList[b].playControl === 1
                      res.autoplay = hotspotList[b].playAuto === 1
                      res.loopplay = hotspotList[b].playLoop === 1
                      res.btnStyle = hotspotList[b].btnStyle
                      res.btnPath = hotspotList[b].btnPath
                      res.btnAttachId = hotspotList[b].btnAttachId
                      res.vodFileId = hotspotList[b].vodFileId
                    }
                    this.pages[a].resources.push(res)
                  }
                }
              }
            }
          }
          this.loadXiaoYangList(this.pageIndex, async (xiaoYangList) => {
            this.digital.changePage(this.pageIndex)
            if (xiaoYangList && xiaoYangList.length > 0) {
              await this.getXiaoYangDetailInfo(xiaoYangList[0].id)
            }
            callback && callback()
          })
        })
      })
    },
    dingDianCoords(dingDianCoords) {
      let arr = dingDianCoords.split(',')
      let xArr = new Array(arr.length / 2)
      let yArr = new Array(arr.length / 2)
      let x = 0,
        y = 0
      let max = 1,
        min = 2
      for (let t = 0; t < arr.length; t = t + 2) {
        xArr[x++] = parseInt(arr[t])
      }
      for (let t = 1; t < arr.length; t = t + 2) {
        yArr[y++] = parseInt(arr[t])
      }
      let x1 = this.find(xArr, min)
      let x2 = this.find(xArr, max)
      let y1 = this.find(yArr, min)
      let y2 = this.find(yArr, max)
      let Left = x1
      let Top = y1
      let Right = parseInt(x2 - x1)
      let Bottom = parseInt(y2 - y1)
      return {
        top: Top,
        left: Left,
        width: Right,
        height: Bottom
      }
    },
    find(arr, type) {
      let tmp = arr[0]
      if (type == 1) {
        for (let loop = 0; loop < arr.length; loop++) if (arr[loop] > tmp) tmp = arr[loop]
        return tmp
      } else if (type == 2) {
        for (let loop = 0; loop < arr.length; loop++) if (arr[loop] < tmp) tmp = arr[loop]
        return tmp
      }
    },
    /**
     * 数字报详情 - 小样列表
     * @param params
     * @param callback
     */
    getXiaoYangList(params, callback) {
      getBook.getXiaoYangList(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data)
        }
      })
    },
    loadXiaoYangList(pageIndex, callback) {
      let width = this.pages[pageIndex - 1]?.width
      let height = this.pages[pageIndex - 1]?.height
      let dayangid = this.pages[pageIndex - 1]?.dayangid
      if (width === undefined || height === undefined || dayangid === undefined) {
        return
      }
      // 获取小样列表
      const params = {
        dayangId: dayangid
      }
      this.getXiaoYangList(params, (xiaoYangList) => {
        let xiaoyangindex = 1
        this.pages[pageIndex - 1].coordinates = []
        for (let b in xiaoYangList) {
          if (xiaoYangList.hasOwnProperty(b)) {
            let dingDianCoords = []
            let coordinates = JSON.parse(xiaoYangList[b].coordinates)
            if (!coordinates) {
              continue
            }
            let zIndex = coordinates.zIndex >= 0 ? coordinates.zIndex : Math.abs(xiaoYangList.length - b - 1)
            if (coordinates.dingDianCount === 1) {
              this.pages[pageIndex - 1].coordinates.push({
                type: 'area',
                top: coordinates.top,
                left: coordinates.left,
                width: coordinates.width,
                height: coordinates.height,
                topScale: coordinates.top,
                leftScale: coordinates.left,
                widthScale: coordinates.width,
                heightScale: coordinates.height,
                xiaoyangindex: xiaoyangindex++,
                zIndex: zIndex,
                xiaoyangid: xiaoYangList[b].id
              })
            } else {
              for (let c in coordinates.dingDianList) {
                if (coordinates.dingDianList.hasOwnProperty(c)) {
                  let x = (coordinates.dingDianList[c].split(',')[0].split('%')[0] * width) / 100
                  let y = (coordinates.dingDianList[c].split(',')[1].split('%')[0] * height) / 100
                  dingDianCoords.push(x)
                  dingDianCoords.push(y)
                }
              }
              let dingDianCoordsRect = this.dingDianCoords(dingDianCoords.toString())
              this.pages[pageIndex - 1].coordinates.push({
                edit: !coordinates.zIndex, //文件包小样第一次编辑需设置图层
                type: 'area',
                top: dingDianCoordsRect.top,
                left: dingDianCoordsRect.left,
                width: dingDianCoordsRect.width,
                height: dingDianCoordsRect.height,
                topScale: dingDianCoordsRect.top,
                leftScale: dingDianCoordsRect.left,
                widthScale: dingDianCoordsRect.width,
                heightScale: dingDianCoordsRect.height,
                xiaoyangindex: xiaoyangindex++,
                zIndex: zIndex,
                xiaoyangid: xiaoYangList[b].id
              })
            }
          }
        }
        callback && callback(xiaoYangList)
      })
    },
    getAllPageWH(path, page, total, callback) {
      if (page <= total) {
        this.getPageWH(path, page, (width, height) => {
          this.pageSizeList.push({
            page: page,
            width: width,
            height: height
          })
          this.getAllPageWH(path, page + 1, total, callback)
        })
      } else {
        callback && callback()
      }
    },
    getPageWH(path, page, callback) {
      // 获取目标项目的尺寸数据
      let img = new Image()
      img.src = path + '/' + page + '.jpg?v=' + this.timer
      let targetPage = this.pages[page - 1]
      img.onload = () => {
        // 目标尺寸数据
        let width = img.width
        let height = img.height
        targetPage.width = width
        targetPage.height = height
        this.pageSizeList.push({
          page: page,
          width: width,
          height: height
        })
        callback && callback(width, height)
      }
    },
    /**
     * 获取书箱明细数据
     * @param params
     * @param callback
     */
    getBookDetails(params, callback) {
      let url = this.isPaper ? getBook.GetPaperDetails : getBook.GetMobileBookDetails
      url(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data || {})
        }
      })
    },
    /**
     * 查询富媒体列表
     * @param params
     * @param callback
     */
    getHotspotList(params, callback) {
      getBook.getHotspotList(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data)
        }
      })
    },
    /**
     * 数字报详情 - 大样列表
     * @param params
     * @param callback
     */
    getDaYangByEpaperId(params, callback) {
      getBook.getDaYangByEpaperId(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data)
        }
      })
    },
    async gotoPaper() {
      this.$store.dispatch('common/login')
      this.$store.commit('edit/UPDATE_LIST_TO_PAGE_NO', this.pageIndex)
      this.$store.commit('book/UPDATE_ISSHOWWINDOW', 2)
      const encryption_id = setEncryption(this.$route.query.id)
      this.$store.commit('config/UPDATE_BOOK_ID', this.$route.query.id)
      this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'editContent')
      const isVip = await this.$store.dispatch('common/getVipInfo')
      if (isVip) {
        if (this.isPaper) await this.$router.push({ path: '/paper', query: { id: encryption_id } })
        if (this.isBook) await this.$router.push({ path: '/book', query: { id: encryption_id } })
        if (this.paperStyle) await this.$router.push({ path: '/paperTurn', query: { id: encryption_id } })
      } else {
        this.$refs.memberDialog.visible = true
      }
      this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', true)
    },
    saveReadingLog(pageIndex) {
      // 保存当前阅读的页数
      this.readingLog[this.$route.query.id] = parseInt(pageIndex)
      localStorage.setItem('readingLog', JSON.stringify(this.readingLog))
    },
    getXiaoYangDetail(xiaoYangId, callback) {
      // 根据小样ID获取内容详情
      const params = {
        id: xiaoYangId
      }
      getBook.getXiaoYangDetail(params).then((res) => {
        if (res && res.data && res.status === 200 && res.data.status === 0) {
          callback && callback(formatDigitalArticle(res).data.data)
        } else {
          callback && callback({ title: '', content: '' })
        }
      })
    },
    async getXiaoYangDetailInfo(xiaoYangId) {
      if (xiaoYangId) {
        this.dataLoading = true
        this.articleTextEditStatus = true
        await this.getXiaoYangDetail(xiaoYangId, (data) => {
          this.articleXiaoYangId = xiaoYangId
          this.articleTitle = data.title
          this.articleTitleOld = data.title
          this.articleText = data.content.replaceAll('<nobr>', '').replaceAll('</nobr>', '')
          this.articleTextOld = data.content
          this.articleFileAttachIds = data.fileAttachIds ? data.fileAttachIds.split(',') : []
          this.isEditArticle = false
          setTimeout(() => {
            this.dataLoading = false
            this.articleTextEditStatus = false
          }, 1000)
        })
      } else {
        this.dataLoading = false
        this.articleXiaoYangId = xiaoYangId
        this.articleTitle = ''
        this.articleTitleOld = ''
        this.articleText = ''
        this.articleTextOld = ''
      }
    },
    getFirstArticleXiaoYangId(pageIndex) {
      this.articleIndex = 1
      if (this.articles[pageIndex - 1]?.children && this.isPaper && this.readModel === 2) {
        return this.articles[pageIndex - 1]?.children[0]?.xiaoYangId || 0
      } else if (this.pages && this.pages[pageIndex - 1] && this.pages[pageIndex - 1].coordinates && this.pages[pageIndex - 1].coordinates.length > 0) {
        //手动添加的文章从热区列表中获取小样id
        return this.pages[pageIndex - 1].coordinates[0].xiaoyangid || 0
      } else {
        return 0
      }
    },
    gotoPageAndArticle(pageIndex, xiaoYangId) {
      let togo = () => {
        // 根据报刊类型判断是否需要加载文章及热区数据
        let dayangid = this.pages[pageIndex - 1]?.dayangid
        if (dayangid) {
          // 加载某页面的热区数据
          this.dataLoading = true
          this.loadXiaoYangList(pageIndex, () => {
            this.isEditArticle = false
            this.pageIndex = pageIndex
            this.digital.changePage(pageIndex)
            this.saveReadingLog(pageIndex)
            if (!xiaoYangId) {
              xiaoYangId = this.getFirstArticleXiaoYangId(pageIndex)
            }
            this.getXiaoYangDetailInfo(xiaoYangId)
          })
        } else {
          this.isEditArticle = false
          this.pageIndex = pageIndex
          this.digital.changePage(pageIndex)
          this.saveReadingLog(pageIndex)
          if (!xiaoYangId) {
            xiaoYangId = this.getFirstArticleXiaoYangId(pageIndex)
          }
          this.getXiaoYangDetailInfo(xiaoYangId)
        }
      }
      let goto = () => {
        if (this.pages[pageIndex - 1].width) {
          togo()
        } else {
          this.getPageWH(this.book.path, pageIndex, togo)
        }
      }
      // 检查文章是否未保存
      if (this.isEditArticle) {
        this.digitalTips.status = true
        this.digitalTips.yesCallback = () => {
          // 保存，然后再跳转
          this.save(() => {
            goto()
          })
          // 恢复相关状态
          this.digitalTips.status = false
        }
        this.digitalTips.noCallback = () => {
          // 不保存，直接跳转
          goto()
          // 恢复相关状态
          this.digitalTips.status = false
        }
        this.digitalTips.cancelCallback = () => {
          // 恢复相关状态
          this.$refs.digitalNavigation.recovery()
          this.$refs.digitalSaveButton.recovery()
          this.digitalTips.status = false
        }
      } else {
        goto()
      }
    },
    save(callback) {
      let deleteFileAttachIds = []
      let addFileAttachIds = []
      let hotspotJsonArr = []
      let xiaoYangJsonArr = []
      // 去掉报刊中关于数字内容的部分无用数据，比喻缩放的尺寸与位置数据等
      this.book.pages = this.pages
      let book = JSON.parse(JSON.stringify(this.book))
      for (let a in book.pages) {
        if (book.pages.hasOwnProperty(a)) {
          for (let b in book.pages[a].resources) {
            if (book.pages[a].resources.hasOwnProperty(b)) {
              delete book.pages[a].resources[b].topScale
              delete book.pages[a].resources[b].leftScale
              delete book.pages[a].resources[b].widthScale
              delete book.pages[a].resources[b].heightScale
              // 将富媒体需要的数据PUSH进入hotspotJsonArr
              if (book.pages[a].resources[b].edit) {
                let res = book.pages[a].resources[b]
                let type = undefined
                if (res.type === 'audio') {
                  type = 0
                } else if (res.type === 'video') {
                  type = 1
                } else if (res.type === 'link') {
                  type = 2
                } else if (res.type === 'picture') {
                  type = 3
                } else if (res.type === 'innerVideo') {
                  type = 4
                }
                let contentPath = ''
                if (type === 2) {
                  contentPath = res.href
                } else {
                  if (res.path) {
                    let index = res.path.indexOf('attach')
                    if (index > -1) {
                      contentPath = res.path.substring(index)
                    } else {
                      contentPath = res.path
                    }
                  }
                }
                let hotspot = {
                  contentPath: contentPath,
                  contentType: type,
                  coordinates: JSON.stringify({
                    top: res.top,
                    left: res.left,
                    width: res.width,
                    height: res.height
                  }),
                  fileAttachId: res.fileid,
                  vodFileId: res.vodFileId,
                  fileAttachName: res.file,
                  module: this.isBook ? 'ebook' : 'epaper',
                  moduleDataId: book.id,
                  pageIden: book.pages[a].index,
                  playAuto: res.autoplay ? 1 : 0,
                  playControl: res.controls ? 1 : 0,
                  playLoop: res.loopplay ? 1 : 0,
                  deleteStatus: 1,
                  btnStyle: res.btnStyle && res.btnPath ? 1 : 0,
                  btnPath: res.btnPath || '',
                  btnAttachId: res.btnAttachId || ''
                }
                if (res.id) {
                  hotspot.id = res.id
                }
                hotspotJsonArr.push(hotspot)
              }
            }
          }
          for (let b in book.pages[a].coordinates) {
            if (book.pages[a].coordinates.hasOwnProperty(b)) {
              delete book.pages[a].coordinates[b].topScale
              delete book.pages[a].coordinates[b].leftScale
              delete book.pages[a].coordinates[b].widthScale
              delete book.pages[a].coordinates[b].heightScale
              let res = book.pages[a].coordinates[b]
              if (res.edit || (res.xiaoyangid && res.xiaoyangid == this.articleXiaoYangId)) {
                let hotspot = {
                  module: this.isBook ? 'ebook' : 'epaper',
                  epaperId: book.id,
                  edition: parseInt(a) + 1,
                  pageIden: book.pages[a].index,
                  xuHao: parseInt(b) + 1,
                  deleteStatus: 1
                }
                if (res.edit) {
                  hotspot.coordinates = JSON.stringify({
                    dingDianCount: 1,
                    top: res.top,
                    left: res.left,
                    width: res.width,
                    height: res.height,
                    zIndex: res.zIndex
                  })
                }
                if (res.xiaoyangid && res.xiaoyangid == this.articleXiaoYangId) {
                  let fileAttachArray = this.$refs.digitalArticleEdit.getFileAttachArray(this.articleFileAttachIds)
                  let xiaoYangDeleteFileAttachIds = fileAttachArray.deleteFileAttachIds
                  let xiaoYangAddFileAttachIds = fileAttachArray.addFileAttachIds
                  for (let a in xiaoYangDeleteFileAttachIds) {
                    if (xiaoYangDeleteFileAttachIds.hasOwnProperty(a)) {
                      deleteFileAttachIds.push(xiaoYangDeleteFileAttachIds[a])
                    }
                  }
                  for (let a in xiaoYangAddFileAttachIds) {
                    if (xiaoYangAddFileAttachIds.hasOwnProperty(a)) {
                      addFileAttachIds.push(xiaoYangAddFileAttachIds[a])
                    }
                  }
                  hotspot = {
                    ...hotspot,
                    title: this.articleTitle,
                    content: this.articleText,
                    fileAttachIds: fileAttachArray.fileAttachIds.toString()
                  }
                }
                if (res.xiaoyangid && res.xiaoyangid.toString().indexOf('new') < 0) {
                  hotspot.id = res.xiaoyangid
                }
                hotspot.dayangId = this.pages[a]?.dayangid
                xiaoYangJsonArr.push(hotspot)
              }
            }
          }
        }
      }
      // 将删除的元素放入hotspotJsonArr
      let delResArray = this.digital.delResArray()
      for (let a in delResArray) {
        if (delResArray.hasOwnProperty(a)) {
          let res = delResArray[a]
          if (res.type === 'area') {
            if (res.xiaoyangid) {
              let hotspot = {
                coordinates: JSON.stringify({
                  dingDianCount: 1,
                  top: res.top,
                  left: res.left,
                  width: res.width,
                  height: res.height,
                  zIndex: res.zIndex
                }),
                module: this.isBook ? 'ebook' : 'epaper',
                epaperId: book.id,
                pageIden: res.pageIden,
                deleteStatus: 0,
                id: res.xiaoyangid
              }
              xiaoYangJsonArr.push(hotspot)
            }
          } else {
            let type = undefined
            if (res.type === 'audio') {
              type = 0
            } else if (res.type === 'video') {
              type = 1
            } else if (res.type === 'link') {
              type = 2
            } else if (res.type === 'picture') {
              type = 3
            } else if (res.type === 'innerVideo') {
              type = 4
            }
            let contentPath = ''
            if (type === 2) {
              contentPath = res.href
            } else {
              if (res.path) {
                contentPath = res.path.substring(res.path.indexOf('attach'))
              }
            }
            let hotspot = {
              contentPath: contentPath,
              contentType: type,
              coordinates: JSON.stringify({
                top: res.top,
                left: res.left,
                width: res.width,
                height: res.height
              }),
              fileAttachId: res.fileid,
              fileAttachName: res.file,
              module: this.isBook ? 'ebook' : 'epaper',
              moduleDataId: book.id,
              pageIden: res.pageIden,
              playAuto: res.autoplay ? 1 : 0,
              playControl: res.controls ? 1 : 0,
              playLoop: res.loopplay ? 1 : 0,
              deleteStatus: 0,
              btnStyle: res.btnStyle,
              btnPath: res.btnPath,
              btnAttachId: res.btnAttachId
            }
            if (res.id) {
              hotspot.id = res.id
              hotspotJsonArr.push(hotspot)
            }
          }
        }
      }
      // 将删除的附件ID信息PUSH进入delFileAttachIds
      let digitalPageDelFileAttachIds = this.digital.delFileAttachIds()
      for (let a in digitalPageDelFileAttachIds) {
        if (digitalPageDelFileAttachIds.hasOwnProperty(a)) {
          if (parseInt(digitalPageDelFileAttachIds[a])) {
            deleteFileAttachIds.push(digitalPageDelFileAttachIds[a])
          }
        }
      }
      if (this.deletePic) {
        deleteFileAttachIds = deleteFileAttachIds.concat(this.deletePic)
      }
      // 将添加的附件ID信息PUSH进入addFileAttachIds
      let digitalPageAddFileAttachIds = this.digital.addFileAttachIds()
      for (let a in digitalPageAddFileAttachIds) {
        if (digitalPageAddFileAttachIds.hasOwnProperty(a)) {
          if (parseInt(digitalPageAddFileAttachIds[a])) {
            addFileAttachIds.push(digitalPageAddFileAttachIds[a])
          }
        }
      }
      if (this.addICons && this.addICons.length > 0) {
        addFileAttachIds = addFileAttachIds.concat(this.addICons)
      }
      // 如果存在小样数据，则将小样数据计算进入
      /*if (this.articleXiaoYangId) {
        let fileAttachArray = this.$refs.digitalArticleEdit.getFileAttachArray(this.articleFileAttachIds)
        let xiaoYangDeleteFileAttachIds = fileAttachArray.deleteFileAttachIds
        let xiaoYangAddFileAttachIds = fileAttachArray.addFileAttachIds
        for (let a in xiaoYangDeleteFileAttachIds) {
          if (xiaoYangDeleteFileAttachIds.hasOwnProperty(a)) {
            deleteFileAttachIds.push(xiaoYangDeleteFileAttachIds[a])
          }
        }
        for (let a in xiaoYangAddFileAttachIds) {
          if (xiaoYangAddFileAttachIds.hasOwnProperty(a)) {
            addFileAttachIds.push(xiaoYangAddFileAttachIds[a])
          }
        }
        xiaoYangJsonArr.push({
          id: this.articleXiaoYangId,
          title: this.articleTitle,
          content: this.articleText,
          fileAttachIds: fileAttachArray.fileAttachIds.toString()
        })
      }*/
      // 过滤相同的ID
      let newDeleteFileAttachIds = deleteFileAttachIds.filter((item, index, self) => {
        return self.indexOf(item) === index
      })
      let newAddFileAttachIds = addFileAttachIds.filter((item, index, self) => {
        return self.indexOf(item) === index
      })
      const richMedia = {
        deleteFileAttachIds: newDeleteFileAttachIds.toString(),
        addFileAttachIds: newAddFileAttachIds.toString(),
        hotspotJsonArr: JSON.stringify(hotspotJsonArr),
        xiaoYangJsonArr: JSON.stringify(xiaoYangJsonArr)
      }
      this.dataLoading = true
      setBook.richMediaEditor(richMedia).then(
        (res) => {
          if (res && res.data && res.status === 200 && res.data.status === 0) {
            // 清理数字内容编辑器的数据
            this.digital.clear()
            // 重置大样小样、富媒体元素
            this.reloadHotspotList(() => {
              this.dataLoading = false
              this.$alert('保存成功', '提示', {
                confirmButtonText: '确定',
                callback: () => {
                  callback && callback()
                }
              })
            })
            // 如果编辑了文章，则保存文章后恢复文章为未编辑状态
            if (this.isEditArticle) {
              this.isEditArticle = false
              this.articleTitleOld = this.articleTitle
              this.articleTextOld = this.articleText
              // 更新编辑的文章标题
              if (this.articles[this.pageIndex - 1]) {
                let article = this.articles[this.pageIndex - 1]?.children[this.articleIndex - 1]
                if (article) {
                  article.label = this.articleTitle
                }
              }
            }
          } else if (res && res.data) {
            this.$alert('保存失败：' + res.data.message, '提示', {
              confirmButtonText: '确定'
            })
          }
        },
        () => {
          return Promise.reject('error')
        }
      )
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 相关事件回调
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    onCreate(digital) {
      this.digital = digital
    },
    onChangeTab(tabIndex) {
      console.log(tabIndex)
    },
    onChangePage(page, pageIndex) {
      this.gotoPageAndArticle(pageIndex)
    },
    onChangeArticle(page, article, pageIndex, articleIndex) {
      this.articleIndex = articleIndex
      this.gotoPageAndArticle(pageIndex, article ? article.xiaoYangId : 0)
    },
    onChange(articleTitle, articleText) {
      if (this.articleTextEditStatus === true) {
        this.articleTitleOld = articleTitle
        this.articleTextOld = articleText
      }
      this.articleTitle = articleTitle
      this.articleText = articleText
      this.isEditArticle = !(articleTitle === this.articleTitleOld && articleText === this.articleTextOld)
    },
    onSelectedPageElement(pageSelectedElement) {
      // console.log('onSelectedPageElement', pageSelectedElement)
    },
    onAreaClick(coord) {
      this.articleIndex = coord.xiaoyangindex
      if (this.isEditArticle) {
        this.digitalTips.status = true
        this.digitalTips.yesCallback = () => {
          // 保存，然后再跳转
          this.save(() => {
            this.getXiaoYangDetailInfo(coord.xiaoyangid)
          })
          // 恢复相关状态
          this.digitalTips.status = false
        }
        this.digitalTips.noCallback = () => {
          // 不保存，直接跳转
          this.getXiaoYangDetailInfo(coord.xiaoyangid)
          // 恢复相关状态
          this.digitalTips.status = false
        }
        this.digitalTips.cancelCallback = () => {
          // 恢复相关状态
          this.$refs.digitalNavigation.recovery()
          this.$refs.digitalSaveButton.recovery()
          this.digitalTips.status = false
        }
      } else {
        this.getXiaoYangDetailInfo(coord.xiaoyangid)
      }
    },
    onPrev(pageIndex) {
      this.gotoPageAndArticle(pageIndex)
    },
    onNext(pageIndex) {
      this.gotoPageAndArticle(pageIndex)
    },
    onSave(type) {
      this.save(() => {
        if (type === 'paper') {
          this.$router.push({ name: 'list', params: { to: 'paper', pageNo: this.listToEditPageNo } })
          this.$store.commit('edit/UPDATE_LIST_TO_PAGE_NO', 1)
        } else if (type === 'book') {
          this.$router.push({ name: 'list', params: { to: 'book', pageNo: this.listToEditPageNo } })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.digital-tips {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99999;
  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 300px;
    height: 160px;
    margin-left: -150px;
    margin-top: -80px;
    background: #ffffff;
    font-size: 14px;
    text-align: center;
    .head {
      position: relative;
      .title {
        background: #e3e3e3;
        line-height: 32px;
        font-weight: bold;
      }
      .close {
        position: absolute;
        top: 0;
        right: 0;
        width: 32px;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        &:hover {
          background: #cccccc;
        }
        &:active {
          background: #bbbbbb;
        }
      }
    }
    .tips {
      .text {
        padding: 30px 15px;
        line-height: 1.6em;
      }
    }
    .btns {
      padding-bottom: 15px;
      button {
        width: 70px;
        margin-right: 15px;
        background: #999999;
        color: #ffffff;
        border: none;
        line-height: 28px;
        font-size: 12px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          background: #888888;
        }
        &:active {
          background: #777777;
        }
      }
      .yes {
        background: #df5813;
        &:hover {
          background: #cd5112;
        }
        &:active {
          background: #bd4b10;
        }
      }
    }
  }
}
.digital-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9998;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  .text {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 30px;
    margin-left: -100px;
    margin-top: -15px;
    text-align: center;
    z-index: 9999;
    font-size: 24px;
    color: #ffffff;
  }
}
</style>
<style lang="scss">
.book-content-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: cover;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &_edit {
    width: calc(100% - 300px);
    margin-left: 300px;
  }
  .fd-nobook-container {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .fd-nobook {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 400px;
      height: 267px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      color: #fff;
      img {
        margin-bottom: 20px;
      }
    }
  }
  .book-title {
    background-color: #ffffff;
    // opacity: 0.5;
    height: 40px;
    width: 100%;
    display: flex;
    flex-direction: row;
    color: #000000;
    line-height: 40px;
    z-index: 2;
    font-size: 16px;
    button {
      font-size: 14px;
      cursor: pointer;
    }
    .shareHeader {
      flex: 1;
      height: 40px;
      line-height: 40px;
      text-align: center;
      display: inline-block;
    }
    .digital-button {
      width: 120px;
      margin-right: 7px;
    }
    button {
      width: 80px;
      height: 30px;
      text-align: center;
      outline: none;
      border: 1px solid #000;
      background: none;
      color: #000000;
      margin-top: 5px;
      &.light {
        color: #ffffff;
        border-color: #ffffff;
      }
    }
  }
  .book-content {
    width: 100%;
    flex: 1;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
